import React from "react";
import { Send, Paperclip, Volume2 } from "lucide-react";

const ChatInput = ({
  input, setInput, handleSendMessage, fileInputRef,
  handleFileUpload, isBotTyping, onVoiceButtonClick
}) => {

  const handleSend = () => {
    if (!isBotTyping) handleSendMessage();
  };

  return (
    <div
      className="flex items-center gap-2 shrink-0"
      style={{
        padding: '16px',
        background: 'white',
        borderTop: '1px solid #E5E7EB',
      }}
    >
      {/* Text input */}
      <input
        type="text"
        placeholder="Ask about your portfolio..."
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') { e.preventDefault(); handleSend(); }
        }}
        aria-label="Chat message input"
        style={{
          flex: 1,
          fontSize: '14px',
          lineHeight: '1.4',
          padding: '12px 14px',
          borderRadius: '12px',
          border: '1px solid #D1D5DB',
          outline: 'none',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          backgroundColor: 'white',
          color: '#1F2937',
        }}
        onFocus={e => {
          e.target.style.borderColor = 'var(--color-secondary)';
          e.target.style.boxShadow = '0 0 0 3px rgba(6, 182, 212, 0.1)';
        }}
        onBlur={e => {
          e.target.style.borderColor = '#D1D5DB';
          e.target.style.boxShadow = 'none';
        }}
      />

      {/* Voice button */}
      <button
        type="button"
        aria-label="Voice input"
        onClick={onVoiceButtonClick}
        disabled={isBotTyping}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: '36px', height: '36px', borderRadius: '8px',
          border: 'none', background: 'transparent', cursor: isBotTyping ? 'not-allowed' : 'pointer',
          color: isBotTyping ? '#D1D5DB' : '#6B7280',
          transition: 'color 0.2s ease',
          outline: 'none',
        }}
        onMouseEnter={e => { if (!isBotTyping) e.currentTarget.style.color = 'var(--color-primary)'; }}
        onMouseLeave={e => { if (!isBotTyping) e.currentTarget.style.color = '#6B7280'; }}
      >
        <Volume2 size={20} />
      </button>

      {/* Attach button */}
      <label
        aria-label="Attach file"
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: '36px', height: '36px', borderRadius: '8px',
          cursor: isBotTyping ? 'not-allowed' : 'pointer',
          color: isBotTyping ? '#D1D5DB' : '#6B7280',
          transition: 'color 0.2s ease',
        }}
        onMouseEnter={e => { if (!isBotTyping) e.currentTarget.style.color = 'var(--color-primary)'; }}
        onMouseLeave={e => { if (!isBotTyping) e.currentTarget.style.color = '#6B7280'; }}
      >
        <input
          type="file"
          multiple
          onChange={handleFileUpload}
          className="hidden"
          ref={fileInputRef}
          disabled={isBotTyping}
          aria-hidden="true"
        />
        <Paperclip size={20} />
      </label>

      {/* Send button */}
      <button
        type="button"
        aria-label="Send message"
        onClick={handleSend}
        disabled={isBotTyping}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '10px 14px', borderRadius: '8px',
          border: 'none',
          background: isBotTyping
            ? '#E5E7EB'
            : 'linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%)',
          color: isBotTyping ? '#9CA3AF' : 'white',
          cursor: isBotTyping ? 'not-allowed' : 'pointer',
          fontWeight: 600, fontSize: '14px',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          outline: 'none',
          boxShadow: isBotTyping ? 'none' : '0 2px 6px rgba(0,0,0,0.12)',
        }}
        onMouseEnter={e => {
          if (!isBotTyping) {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.2)';
          }
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = isBotTyping ? 'none' : '0 2px 6px rgba(0,0,0,0.12)';
        }}
        onMouseDown={e => { if (!isBotTyping) e.currentTarget.style.transform = 'scale(0.95)'; }}
        onMouseUp={e => { if (!isBotTyping) e.currentTarget.style.transform = 'scale(1.05)'; }}
      >
        <Send size={16} />
      </button>
    </div>
  );
};

export default ChatInput;
